import { render, staticRenderFns } from "./reportGetting.vue?vue&type=template&id=6f755296&scoped=true&"
import script from "./reportGetting.vue?vue&type=script&setup=true&lang=js&"
export * from "./reportGetting.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./reportGetting.vue?vue&type=style&index=0&id=6f755296&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f755296",
  null
  
)

export default component.exports